import { useEffect } from 'react'
import { applyPublicLightTheme } from '@/lib/theme'

export function usePublicLightTheme() {
  useEffect(() => {
    applyPublicLightTheme()
  }, [])
}
